import { Empty, Spin, theme, Typography } from "antd";
import {
  ColumnComponent,
  ContainerComponent,
  GridComponent,
  RowComponent,
  SearchComponent,
} from "../../../components";
import { DropDownComponent } from "../../../components/dropdown.component";
import { useQuery } from "../../../hooks";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UseCaseItemPartial } from "../../use-cases/partials/use-case-item.partial";

export const CatalogView = () => {
  const location = useLocation();
  const [filter, setFilter] = useState("industries");
  const {
    token: { colorBorder },
  } = theme.useToken();

  const [useCases, setUseCases] = useState([]);

  const { loading: loadingAllUseCases, execute: fetchAllUseCases } = useQuery({
    url: "/usecase",
    options: { method: "GET" },
    onFetch: async (data) => {
      if (data === null) setUseCases([]);
      setUseCases(data);
    },
  });

  // filtro de industrias
  const {
    data: categories,
    loading: loadingCategories,
    execute: fetchCategories,
  } = useQuery({
    url: "/category",
    options: { method: "GET" },
    lazy: true,
  });

  // filtro de tipologias
  const {
    data: typologies,
    loading: loadingTypologies,
    execute: fetchTypologies,
  } = useQuery({
    url: "/typology",
    options: { method: "GET" },
    lazy: true,
  });

  const { loading: loadingUseCases, execute: fetchUseCasesByIndustry } =
    useQuery({
      url: "/usecase/industry/{idIndustry}",
      options: { method: "GET" },
      lazy: true,
      onFetch: async (data) => {
        if (data === null) setUseCases([]);
        setUseCases(data);
      },
    });

  const { loading: loadingUseCasesTypology, execute: fetchUseCasesByTypology } =
    useQuery({
      url: "/usecase/typology/{idTypology}",
      options: { method: "GET" },
      lazy: true,
      onFetch: async (data) => {
        if (data === null) setUseCases([]);
        setUseCases(data);
      },
    });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filter = params.get("filter");

    setFilter(filter || "industries");

    if (filter === "industries") fetchCategories();
    else if (filter === "typologies") fetchTypologies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ContainerComponent
      style={{
        width: "100%",
        padding: 32,
        borderRadius: 8,
        alignItems: "start",
        minHeight: "calc(100vh - 64px)",
      }}
    >
      <ContainerComponent style={{ alignItems: "start" }}>
        <Typography.Title
          level={2}
          style={{
            justifyContent: "start",
            fontWeight: "bold",
            marginBottom: 8,
          }}
        >
          Catálogo de Casos de Uso
        </Typography.Title>
      </ContainerComponent>
      <RowComponent style={{ width: "100%" }}>
        <SearchComponent
          onSearch={async (value) => {
            if (value === null || value === undefined) {
              await fetchAllUseCases();
              return;
            }
            await fetchAllUseCases().then((data) => {
              // filter use cases by name
              const filteredUseCases = data.filter((useCase) => {
                return useCase.name.toLowerCase().includes(value.toLowerCase());
              });
              setUseCases(filteredUseCases);
            });
          }}
          onClear={async () => {
            await fetchAllUseCases();
          }}
        />
        <DropDownComponent
          options={categories}
          placeHolder="Filtrar por industria"
          showSearch
          onChange={async (value) => {
            if (value === null || value === undefined) {
              await fetchAllUseCases();
              return;
            }
            fetchUseCasesByIndustry({
              pathParams: { idIndustry: value },
            });
          }}
        />
      </RowComponent>

      <RowComponent style={{ marginTop: 16 }}>
        <ColumnComponent
          style={{
            marginRight: 32,
            border: `1px solid ${colorBorder}`,
            borderRadius: 16,
            height: "fit-content",
            maxWidth: 300,
            backgroundColor: "white",
            padding: 16,
            minHeight: "calc(100vh - 64px)",
          }}
        >
          <ColumnComponent style={{ alignItems: "start", width: "100%" }}>
            <Typography.Title level={5}>
              {filter === "industries" ? "Industrias" : "Tipologías"}
            </Typography.Title>
            {(loadingCategories || loadingTypologies) && <Spin size="small" />}
            {categories &&
              filter === "industries" &&
              categories.map((category) => (
                <ContainerComponent
                  key={category.id}
                  style={{
                    width: "100%",
                    padding: 8,
                    marginBottom: 8,
                    borderRadius: 8,
                    textAlign: "start",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    fetchUseCasesByIndustry({
                      pathParams: { idIndustry: category.id },
                    });
                  }}
                >
                  {category.name}
                </ContainerComponent>
              ))}

            {typologies &&
              filter === "typologies" &&
              typologies.map((category) => (
                <ContainerComponent
                  key={category.id}
                  style={{
                    width: "100%",
                    padding: 8,
                    marginBottom: 8,
                    borderRadius: 8,
                    textAlign: "start",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    fetchUseCasesByTypology({
                      pathParams: { idTypology: category.id },
                    });
                  }}
                >
                  {category.name}
                </ContainerComponent>
              ))}
          </ColumnComponent>
        </ColumnComponent>

        <ContainerComponent
          style={{
            backgroundColor: "white",
            padding: 16,
            borderRadius: 16,
            flex: 1,
            minHeight: "calc(100vh - 64px)",
          }}
        >
          {loadingUseCases || loadingUseCasesTypology || loadingAllUseCases ? (
            <Spin size="large" />
          ) : useCases === null || useCases?.length === 0 ? (
            <Empty
              image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
              styles={{ image: { height: 60 } }}
              description={
                <Typography.Text style={{ textAlign: "center", color: "gray" }}>
                  Aun no hay casos de uso disponibles para esta industria.
                </Typography.Text>
              }
            />
          ) : (
            <GridComponent maxColumns={3}>
              {useCases?.map((useCase) => (
                <UseCaseItemPartial key={useCase.id} {...useCase} />
              ))}
            </GridComponent>
          )}
        </ContainerComponent>
      </RowComponent>
    </ContainerComponent>
  );
};

export const CatalogRoute = "/catalog";
